import MasterCardLogo from 'assets/svgs/creditCards/mastercard.svg';
import VisaLogo from 'assets/svgs/creditCards/visa.svg';
import AmexLogo from 'assets/svgs/creditCards/amex.svg';
import DefaultBankLogo from 'assets/svgs/banks/default.svg';

export const CreditCards = Object.freeze({
  mastercard: 'Mastercard',
  visa: 'Visa',
  amex: 'AMEX',
  other: 'Other',
});

export const CreditCardsIcons = Object.freeze({
  [CreditCards.mastercard]: MasterCardLogo,
  [CreditCards.visa]: VisaLogo,
  [CreditCards.amex]: AmexLogo,
});

export const getCreditCardIcon = (name) => CreditCardsIcons[name] || DefaultBankLogo;
